import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/AvailableBikes.css';

function AvailableBikes() {
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/vehicles`, {
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Failed to fetch vehicles');
        }
        const data = await response.json();
        console.log('API response:', data); // Debug: Log raw API response
        // Filter for available vehicles using availability property
        console.log('Filtered vehicles:', data); // Debug: Log filtered vehicles
        setVehicles(data);
      } catch (err) {
        setError('Unable to load vehicles. Please try again later.');
        console.error('Fetch vehicles error:', err);
      }
    };

    fetchVehicles();
  }, []);

  return (
    <section className="available-bikes-section">
      <div className="section-header">
        <h2>
          Bikes <span>Available</span> at Beaver Tours
        </h2>
        <p>Premium bikes ready for your next adventure.</p>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="bike-grid">
        {vehicles.length === 0 && !error ? (
          <div className="no-bikes">No available bikes found.</div>
        ) : (
          vehicles.map((vehicle, index) => (
            <motion.div
              key={vehicle._id}
              className="bike-card"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="bike-img-container">
                <img
                  src={vehicle.imageUrl}
                  alt={vehicle.name}
                  className="bike-img"
                  onError={(e) => (e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found')}
                />
                <div className="bike-shadow" />
              </div>
              <h3>{vehicle.name}</h3>
              <div className="bike-prices-grid">
                <div className="bike-price-cell">
                  <span className="bike-price-label">Hourly</span>
                  <span className="bike-price-value">₹{vehicle.prices.hourly}</span>
                </div>
                <div className="bike-price-cell">
                  <span className="bike-price-label">Weekly</span>
                  <span className="bike-price-value">₹{vehicle.prices.weekly}</span>
                </div>
                <div className="bike-price-cell">
                  <span className="bike-price-label">Monthly</span>
                  <span className="bike-price-value">₹{vehicle.prices.monthly}</span>
                </div>
              </div>
              <div className="dott ed-line" />
            </motion.div>
          ))
        )}
      </div>
    </section>
  );
}

export default AvailableBikes;